<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <div class="modal-window-header gray">
        <div class="modal-window-heading">
          <h3 class="icon-heading small">
            <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg></span>
            <span v-if="fullmakt">Oppdater fullmakt</span>
            <span v-else>Ny fullmakt</span>
          </h3>
        </div>

        <fieldset>
          <div class="grid-x grid-padding-x">
            <ThePhoneInput containerClassName="cell large-12 medium-12" label="Telefonnummer" name="Telefon" v-model.trim="form.Telefon" maxlength="20" required v-validate="'required|max:20'"/>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-body">
        <fieldset>
          <div class="grid-x grid-padding-x">
            <TheTextInput containerClassName="cell large-6 medium-6" label="Fornavn" name="Fnavn" v-model.trim="form.Fnavn" maxlength="70" v-validate="'max:70'"/>
            <TheTextInput containerClassName="cell large-6 medium-6" label="Etternavn" name="Enavn" v-model.trim="form.Enavn" maxlength="70" v-validate="'max:70'"/>

            <ThePhoneInput containerClassName="cell large-6 medium-6" label="Mobil" name="Mobil" v-model.trim="form.Mobil" maxlength="20" v-validate="'max:20'"/>
            <TheTextInput containerClassName="cell large-6 medium-6" label="E-post" name="Email" v-model.trim="form.Email" maxlength="255" v-validate="'max:255|email'"/>

            <TheTextInput containerClassName="cell large-6 medium-6" label="Adressefelt 1" name="Adresse" v-model.trim="form.Adresse" maxlength="75" v-validate="'max:100'"/>
            <TheTextInput containerClassName="cell large-6 medium-6" label="Adressefelt 2" name="Adresse2" v-model.trim="form.Adresse2" maxlength="75" v-validate="'max:100'"/>

            <TheTextInput containerClassName="cell large-6 medium-6" label="Postnummer" name="Postnr" v-model.trim="form.Postnr" maxlength="10" v-validate="'max:10'"/>
            <TheTextInput containerClassName="cell large-6 medium-6" label="Poststed" name="Poststed" v-model.trim="form.Poststed" maxlength="70" v-validate="'max:70'"/>

            <TheSelectInput v-model="form.Landkode" containerClassName="cell medium-6" label="Land" name="Landkode" :items="instillinger.land"/>
            <div class="cell large-6 medium-6">
              <label for="Utlopsdato">Utløpsdato</label>
              <div class="input-container date dropdown-top" :class="{'form-error': errors.has('Utlopsdato')}">
                <b-datepicker
                  :show-week-number="false"
                  :editable="false"
                  :first-day-of-week="1"
                  v-model="form.Utlopsdato"
                  name="Utlopsdato"
                  data-vv-validate-on="input"
                  placeholder="Vis kalender..."
                  icon="calendar-today"
                  ref="Utlopsdato"
                  id="Utlopsdato">
                  <button class="button disabled" v-if="!form.Utlopsdato" @click.prevent="$refs.Utlopsdato.toggle()"><span>Slett dato</span></button>
                  <button class="button" v-else @click.prevent="form.Utlopsdato = null"><span>Slett dato</span></button>
                </b-datepicker>
                <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                <span class="form-error-label" v-if="errors.has('Utlopsdato')">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                  {{errors.first('Utlopsdato')}}
                </span>
              </div>
            </div>

            <div class="cell large-6 medium-6">
              <label for="Legtype">Legitimasjonstype</label>
              <div class="select-container" :class="{ 'form-error': errors.has('Legtype') }">
                <select id="Legtype" name="Legtype" v-model="form.Legtype" @change="$validator.validate('Legitimert'); form.Legitimert = false;">
                  <option v-for="option in instillinger.legitimasjon" v-bind:value="option.key" v-bind:key="option.key" :disabled="option.disabled ? true : false">{{option.val}}</option>
                </select>
                <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
                <span class="form-error-label" v-if="errors.has('Legtype')">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                  {{errors.first('Legtype')}}
                </span>
              </div>
            </div>

            <div class="cell large-6 medium-6">
              <label>Legitimert <span v-if="form.Legtype">*</span></label>
              <div class="radio-button-container" :class="{ 'form-error': errors.has('Legitimert') }">
                <ul>
                  <li><input type="radio" :disabled="!form.Legtype" v-model="form.Legitimert" v-bind:value="false" name="Legitimert" id="ikke-legitimert" v-validate="{ included: form.Legtype ? ['true', true] : [] }"> <label for="ikke-legitimert">Nei</label></li>
                  <li><input type="radio" :disabled="!form.Legtype" v-model="form.Legitimert" v-bind:value="true" name="Legitimert" id="legitimert" checked> <label for="legitimert">Ja</label></li>
                </ul>
              </div>
            </div>
            <div class="cell large-6 medium-6">&nbsp;</div>
            <div class="cell large-6 medium-6" style="margin-top: -1.3rem;">
              <div class="input-container" :class="{ 'form-error': errors.has('Legitimert') }">
                <label>&nbsp;</label>
                <span class="form-error-label" v-if="errors.has('Legitimert')">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                  Vennligst bekreft legitimasjonen
                </span>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

            <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Lagre</a>
            <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading" disabled>Lagrer...<span class="loader-spinner"></span></a>
            <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Lagre</a>
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </form>
  </overlay-scrollbars>
</template>

<script>
import KundeService from '@/services/KundeService'
// import bus from '@/plugins/event-bus'
import moment from 'moment'

export default {
  name: 'KundeFullmaktFormModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    fullmakt: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      form: {},
      instillinger: {
        land: [],
        legitimasjon: []
      }
    }
  },
  created () {
    // Set form not submittable
    this.setFormLoading(true)

    // Make the form object
    this.makeFormItem()

    // Load data needed in the form
    this.fetch()
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
  },
  watch: {
    'form.Utlopsdato': function (newVal) {
      if (newVal && typeof newVal === 'string') {
        this.form.Utlopsdato = new Date(Date.parse(this.form.Utlopsdato))
      }
    }
  },
  methods: {
    makeFormItem: function () {
      let defaults = {
        Landkode: 'NO',
        Legtype: null,
        Legitimert: false
      }

      if (this.fullmakt) {
        this.$helpers.setObjectValues(defaults, this.fullmakt)
        this.form = this._.cloneDeep(this.fullmakt)
      } else {
        this.form = Object.assign({}, this.form, defaults)
      }

      if (this.form.Utlopsdato) {
        this.form.Utlopsdato = new Date(Date.parse(this.form.Utlopsdato))
      }

      if (this.form.Legtype === 0 || this.form.Legtype === '0') {
        this.form.Legtype = null
      }
    },
    fetch: function () {
      // Add a temp item in all dropdowns, where it show that it is loading...
      this.instillinger.land.unshift({key: this.form.Landkode, val: 'Laster...'})
      this.instillinger.legitimasjon.unshift({key: this.form.Legtype, val: 'Laster...'})

      KundeService.loadFormDropdowns()
        .then((data) => {
          this.instillinger.land = data.land
          this.instillinger.land.unshift({key: null, val: 'Velg land'})

          this.instillinger.legitimasjon = data.legitimasjon
          this.instillinger.legitimasjon.unshift({key: null, val: 'Velg legitimasjonstype'})
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.setFormLoading(false)
        })
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.setFormLoading(false)
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // No errors, so try to save
            let payload = {
              kundenr: this.kunde.Kundenr,
              fullmaktId: null,
              data: this.form
            }

            if (payload.data.Utlopsdato) {
              const df = new Date(Date.parse(payload.data.Utlopsdato))
              payload.data.Utlopsdato = moment(df).format('YYYY-MM-DD')
            }

            this.$store.dispatch('kundefullmakt/save', payload)
              .then(() => {
                this.$helpers.showSuccessAlert('Fullmakt er lagret')
                this.setFormProcessing(false)
                this.closeModal()
              })
              .catch(() => {
                this.$helpers.showErrorAlert('Kunne ikke lagre fullmakt', 'Vennligst prøv igjen')
                this.setFormProcessing(false)
              })

            /*
            KundeService.addKundeKontrakt(this.kunde.Kundenr, this.form)
              .then((response) => {
                // Take care of the response
                let newKontrakt = response.data

                // Show success alert
                this.$helpers.showSuccessAlert('Kontrakt er lagret')

                // Emit event so we can update list
                bus.$emit('kunde-kontrakt-created', newKontrakt)

                this.closeModal()
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
            */
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeFullmaktFormModal.vue